import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FaChevronLeft, FaChevronRight, FaTrash ,FaImages} from "react-icons/fa";
import Swal from "sweetalert2";

const ITEMS_PER_PAGE = 10;

const ListNews = () => {
  const [news, setNews] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(news.length / ITEMS_PER_PAGE);
  const startIdx = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentItems = news.slice(startIdx, startIdx + ITEMS_PER_PAGE);

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/get_all_news`
        );
        const data = await response.json();

        setNews(data.data || []);
      } catch (error) {
        console.error("Error fetching Legal", error);
      }
    };

    fetchTeamMembers();
  }, []);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/delete_news/${id}`,
          {
            method: "DELETE",
          }
        );

        const data = await response.json();

        if (response.ok && data.success) {
          const updatedList = news.filter((member) => member._id !== id);
          setNews(updatedList);

          const totalPagesAfterDelete = Math.ceil(
            updatedList.length / ITEMS_PER_PAGE
          );
          if (currentPage > totalPagesAfterDelete) {
            setCurrentPage(totalPagesAfterDelete);
          }

          Swal.fire({
            title: "Deleted!",
            text: "News has been deleted.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: data.message || "Failed to delete News.",
            icon: "error",
          });
        }
      } catch (error) {
        console.error("Delete error:", error);
        Swal.fire({
          title: "Error!",
          text: "Server error while deleting.",
          icon: "error",
        });
      }
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleNext = () => handlePageChange(currentPage + 1);
  const handlePrev = () => handlePageChange(currentPage - 1);

  // const generatePagination = () => {
  //   const pages = [];

  //   if (totalPages <= 6) {
  //     for (let i = 1; i <= totalPages; i++) {
  //       pages.push(i);
  //     }
  //   } else {
  //     if (currentPage <= 4) {
  //       pages.push(1, 2, 3, 4, 5, "...", totalPages);
  //     } else if (currentPage >= totalPages - 3) {
  //       pages.push(
  //         1,
  //         "...",
  //         totalPages - 4,
  //         totalPages - 3,
  //         totalPages - 2,
  //         totalPages - 1,
  //         totalPages
  //       );
  //     } else {
  //       pages.push(
  //         1,
  //         "...",
  //         currentPage - 1,
  //         currentPage,
  //         currentPage + 1,
  //         "...",
  //         totalPages
  //       );
  //     }
  //   }

  //   return pages;
  // };

  const renderPageNumbers = () => {
    const pages = [];

    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push("...");

      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 2) pages.push("...");
      pages.push(totalPages);
    }

    return pages.map((page, i) =>
      page === "..." ? (
        <span key={i} className="px-2 text-gray-500 select-none">
          ...
        </span>
      ) : (
        <button
          key={i}
          onClick={() => setCurrentPage(page)}
          className={`px-3 py-1 rounded-full text-sm font-medium ${
            currentPage === page
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
          {page}
        </button>
      )
    );
  };

  return (
    <div className="bg-gray-100 p-4 sm:p-6 ">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-6xl mx-auto bg-white p-6 shadow-lg rounded-xl"
      >
        <h2 className="text-2xl font-bold mb-10 text-gray-800 text-center">
          News List
        </h2>

        <div className="overflow-x-auto">
          <table className="min-w-full text-center bg-white border border-gray-200">
            <thead className="bg-gray-100 text-black">
              <tr className="text-center">
                <th className="px-4 py-3 border">Sr. No</th>
                <th className="px-4 py-3 border">Title</th>
                <th className="px-4 py-3 border">Description</th>
                <th className="px-4 py-3 border">Date</th>
                <th className="px-4 py-2 border">Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  <motion.tr
                    key={item.id}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.05 }}
                    className="border-b hover:bg-gray-50"
                  >
                    <td className="px-4 py-3">{startIdx + index + 1}</td>
                    <td className="px-4 py-3">{item.title}</td>
                    <td className="px-4 py-3 text-gray-700 text-sm">
                      {item.description}
                    </td>
                    <td className="px-4 py-3">
                      {new Date(item.date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}
                    </td>
                    <td className="py-3 px-4">
                      <button
                        onClick={() => handleDelete(item._id)}
                        className="text-red-600 hover:text-red-800 transition"
                        title="Delete"
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </motion.tr>
                ))
              ) : (
                <tr>
                  <td colSpan="14" className="py-6 text-gray-500 text-center">
                  <div className="flex flex-col items-center justify-center py-20">
                      <FaImages className="text-5xl text-gray-300 mb-4" />
                      <p className="text-xl text-gray-500 font-medium">
                        No News available.
                      </p>
                      <p className="text-sm text-gray-400 mt-1">
                        Once News are uploaded, they’ll show up here.
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {news.length > 10 && (
          <div className="flex justify-center items-center mt-6 gap-2 flex-wrap">
            <button
              onClick={handlePrev}
              disabled={currentPage === 1}
              className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
            >
              <FaChevronLeft size={14} />
            </button>

            {renderPageNumbers()}

            <button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
            >
              <FaChevronRight size={14} />
            </button>
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default ListNews;
